import React from "react";
import logo from "../../images/logo.svg";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="row">
        <img src={logo} className="logo" alt="Logo" />
      </div>
      <div className="row site-policy">
        <a
          href={process.env.REACT_APP_TERMS_OF_USE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>利用規約</span>
        </a>
        <a
          href={process.env.REACT_APP_PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>個人情報の取扱いについて</span>
        </a>
      </div>
      <div className="row copyright">© Wemex Corporation.</div>
    </div>
  );
}

export default Footer;
